export const AUTH_STORAGE_KEY = "pargro_is_authenticated";
export const AUTH_SESSION_STORAGE_KEY = "pargro_auth_session";

// Active users get a silent refresh shortly before Cognito's access token
// expires. Inactive users keep their current session, but it is not extended.
export const AUTH_REFRESH_BUFFER_MS = 5 * 60 * 1000;
export const AUTH_INACTIVITY_LIMIT_MS = 15 * 60 * 1000;
export const AUTH_ACTIVITY_WRITE_INTERVAL_MS = 30 * 1000;

export const AUTH_ERROR_MESSAGES = Object.freeze({
  cognitoNotConfigured:
    "Cognito is not configured. Set REACT_APP_COGNITO_USER_POOL_ID and REACT_APP_COGNITO_CLIENT_ID.",
  signInFailed: "Unable to sign in.",
  sessionExpired: "Your session has expired. Please sign in again.",
  credentialsRequired: "Enter username and password.",
  passwordResetSessionExpired:
    "Password reset session expired. Please sign in again.",
  passwordResetReauthRequired:
    "Please sign in again to reset your temporary password.",
  passwordResetFieldsRequired: "Enter and confirm your new password.",
  passwordResetMismatch: "New password and confirm password must match.",
  passwordResetFailed: "Unable to reset password.",
});
